module.exports = __webpack_public_path__ + "img/BG121246419.e337346f.png";